import { useState } from "react";
import { Flex, Text, Grid } from "@chakra-ui/react";
import ProductDetailModal from "../../../components/ProductDetailModal";
import ProductCard from "./ProductCard";

const calculateColumns = (productCount) => {
  if (productCount === 0) {
    return 1; 
  } else if (productCount <= 2) {
    return 2; 
  } else if (productCount <= 3) {
    return 3; 
  } else {
    return 4;
  }
};

const ProductsData = ({ store }) => {
  const [detailModal, setDetailModal] = useState({
    visible: false,
    product: {},
  })
  const { products } = store;
  const numColumns = calculateColumns(products.length);

  const openDetails = (product) => {
    setDetailModal({
      visible: true,
      product,
    });
  };

  const closeDetails = () => {
    setDetailModal({
      visible: false,
      product: {},
    });
  };

  return (
    <Flex
      flex={1}
      w="100%"
      minH="400px"
      justifyContent="center"
      alignItems="center"
      flexDir={"column"}
    >
        <ProductDetailModal
            product={detailModal.product}
            visible={detailModal.visible}
            onClose={closeDetails}
            store={store}
        />

      <Grid
        templateColumns={{
          base: "repeat(1, 1fr)",
          md: "repeat(2, 1fr)",
          lg: `repeat(${Math.min(numColumns, 3)}, 1fr)`, // Limitar el número de columnas a 3 en la pantalla LG
          xl: `repeat(${Math.min(numColumns, 4)}, 1fr)`, // Limitar el número de columnas a 4 en la pantalla XL
        }}
        w="100%"
        gap="30px"
      >
        {
          products.length === 0 && (
            <Flex flexDir='column' textAlign='center'>
              <Text fontSize="1m" fontWeight="400">
                Aún no hay productos 
              </Text>
              <Text fontSize="1em" fontWeight="400">
                Te invitamos a que regreses pronto ❤️
              </Text>
            </Flex>
          )
        }
        {products.map((product) => (
          <ProductCard product={product}  openDetails={openDetails} />
        ))}
      </Grid>

    </Flex>
  );
};

export default ProductsData;
